import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="w-full bg-white px-5 py-14 sm:px-6 sm:py-20" data-id="element-92" data-mp="1cl643e2o3sj6">
      <div className="mx-auto max-w-4xl" data-id="element-93" data-mp="1clfx7aj0eft3">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.18em] text-[#B8801F]" data-id="element-94" data-mp="18k4cnjezskrr">
          🎁 Bonus esclusivi
        </p>
        <h2 className="mt-3 text-center font-display text-[1.8rem] font-bold leading-[1.1] text-[#0E3B42] sm:text-[2.5rem]" data-id="element-95" data-mp="25928z62e4qr1">
          Inoltre, riceverai questi{' '}
          <em className="font-semibold italic text-[#17808D]" data-id="element-96" data-mp="1w8dr209vm68v">5 Bonus</em>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-[#3F5F64] sm:text-base" data-id="element-97" data-mp="1ralrck2zpfu4">
          Progettati per eliminare i dubbi che più spesso frenano un medico nella
          prescrizione dei GLP-1.
        </p>

        <div className="mx-auto mt-6 flex max-w-xs flex-col items-center rounded-2xl bg-[#F3EDE3] px-5 py-4 text-center" data-id="element-98" data-mp="ftlztqogv515">
          <span className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-[#8A6314]" data-id="element-99" data-mp="1eru4ytz5otfb">
            Valore totale
          </span>
          <span className="mt-1 font-display text-3xl font-bold text-[#0E3B42]" data-id="element-100" data-mp="15tru7mpmemeu">
            €275
          </span>
          <span className="mt-1 text-[12.5px] font-semibold text-[#4A6B70]" data-id="element-101" data-mp="1aqqnk31gmpbz">
            Oggi inclusi senza alcun costo aggiuntivo
          </span>
        </div>

        <ul className="mt-9 space-y-4 sm:mt-12 sm:space-y-5" data-id="element-102" data-mp="10tm1e37m6tv6">
          {bonuses.map(bonus => <li key={bonus.number} className="overflow-hidden rounded-2xl border border-[#0E3B42]/10 bg-[#FBF8F3]" data-id="element-103" data-mp="n2qvmzsewsvt">
              <div className="flex items-center gap-2.5 bg-[#D79B2B] px-5 py-3 sm:px-6" data-id="element-104" data-mp="r4c6kfldyx3d">
                <GiftIcon className="h-4 w-4 shrink-0 text-[#2A1B00]" aria-hidden="true" data-id="element-105" data-mp="d4t8kfmah24s" />
                <span className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-[#2A1B00]" data-id="element-106" data-mp="2jsbjarhlse7q">
                  {bonus.number}
                </span>
              </div>
              <div className="px-5 py-5 sm:px-6 sm:py-6" data-id="element-107" data-mp="2f00jdomv4sf6">
                <img src={bonus.image} alt={`Anteprima del ${bonus.number}: ${bonus.title}`} className="mx-auto mb-5 w-full max-w-[22rem]" width={1254} height={1254} loading="lazy" data-id="element-108" data-mp="2b11h6bsin9rf" />
                <h3 className="font-display text-[1.15rem] font-bold leading-tight text-[#0E3B42] sm:text-[1.5rem]" data-id="element-109" data-mp="2yqcaj87je1vj">
                  {bonus.title}
                </h3>
                <p className="mt-3 text-[14.5px] leading-relaxed text-[#3F5F64]" data-id="element-110" data-mp="2osg1qn22nj0l">
                  {bonus.lead}
                </p>

                <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[0.16em] text-[#17808D]" data-id="element-111" data-mp="1id5mfcmibrxa">
                  {bonus.listTitle}
                </p>
                <ul className="mt-3 space-y-2.5" data-id="element-112" data-mp="139cad7w9nre8">
                  {bonus.items.map(item => <li key={item} className="flex gap-2.5" data-id="element-113" data-mp="186un79demqri">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#17808D]" aria-hidden="true" data-id="element-114" data-mp="185b47b0d61m1" />
                      <span className="text-[14px] leading-snug text-[#0E3B42]" data-id="element-115" data-mp="1hyrzkjg5fort">
                        {item}
                      </span>
                    </li>)}
                </ul>

                <p className="mt-5 rounded-xl bg-white p-3.5 text-[14px] leading-snug text-[#0E3B42]" data-id="element-116" data-mp="1qwar86oat1co">
                  <span className="font-bold text-[#17808D]" data-id="element-117" data-mp="1vv5gnrgrto5r">Risultato: </span>
                  {bonus.result}
                </p>

                <div className="mt-5 flex flex-wrap items-center gap-2 border-t border-[#0E3B42]/10 pt-4" data-id="element-118" data-mp="1jgzdin2h9i7">
                  <span className="text-[13px] font-semibold text-[#4A6B70] line-through" data-id="element-119" data-mp="6hs9luh9xm0y">
                    Valore: {bonus.value}
                  </span>
                  <span className="rounded-full bg-[#0E3B42] px-3 py-1 text-[11px] font-extrabold uppercase tracking-[0.12em] text-white" data-id="element-120" data-mp="1x1ib2gmjwsbf">
                    Oggi è tuo gratis
                  </span>
                </div>
              </div>
            </li>)}
        </ul>

        <CTAButton className="mt-10" variant="gold" label="Voglio tutti i 5 bonus inclusi" subline="€275 di bonus inclusi senza costi aggiuntivi" data-id="element-121" data-mp="211it0b8uzln8" />
      </div>
    </section>;
}